import { render, staticRenderFns } from "./index.vue?vue&type=template&id=989e2a12&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('989e2a12')) {
      api.createRecord('989e2a12', component.options)
    } else {
      api.reload('989e2a12', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=989e2a12&", function () {
      api.rerender('989e2a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file-previewer/index.vue"
export default component.exports